<button
  class="nav__button"
  [class.active]="active()"
  [class.compact]="isScrolled"
  [attr.title]="label()"
  [attr.aria-label]="label()"
  [attr.aria-pressed]="active()"
>
  <ci-icon 
    [name]="iconName()" 
    type="svg"
    scale="1.5x"
  ></ci-icon>
  
  @if (!isScrolled) {
    <span 
      class="nav__text ci-caption-regular"
      [class.ci-caption-semibold]="active()"
    >
      {{ label() }}
    </span>
  }
</button>